export default function updateXrefsForProductService($http) {
  'ngInject';

  return function (requestId, productId, xrefs, purchasePlanId) {
    console.warn(
      'The updateXrefsForProductService has been deprecated and will be removed from a future release.'
    );

    return $http.post(
      '/aptitude/buyer/PurchasePlanServiceController/updateXrefsForProduct',
      {
        requestId: requestId,
        productId: productId,
        xrefs: xrefs
        /*
         * @param xrefs
         * [
         *   {
         *     allocation: 10
         *     id: 40257021 - productId
         *   }
         * ]
         * */
      },
      { params: { purchasePlanId: purchasePlanId } }
    );
  };
}
